import Services from '../../service/ApiServices'
import _ from 'lodash'


export const SET_FILTER = "ATTENDANCE/SET_FILTER"
export const RESET_FILTER = "ATTENDANCE/RESET_FILTER"
export const SELECTED_DATE = "ATTENDANCE/SELECTED_DATE"
export const SET_SELECTED_LOCATIONS = "ATTENDANCE/SET_SELECTED_LOCATIONS"
export const SET_DEFAULT_EXPANDED_KEYS = "ATTENDANCE/SET_DEFAULT_EXPANDED_KEYS"
export const INITIALIZE_DEFAULTS = "ATTENDANCE/INITIALIZE_DEFAULTS"
export const MARK_ATTENDANCE = "ATTENDANCE/MARK_ATTENDANCE"

export const InitialDefaults = (date, selectedLocations)=>{
    return {type: INITIALIZE_DEFAULTS, defaults:{date, selectedLocations}}
}

export const SetSelectedDate = (date)=>{
    return {type: SELECTED_DATE, date:date}
}

export const SetSelectedLocations = (selectedLocations)=>{
    return {type: SET_SELECTED_LOCATIONS, selectedLocations}
}

export const SetFilter = (data)=>{
    return {type: SET_FILTER, filter:data}
}

export const ResetFilter = ()=>{
    return {type: RESET_FILTER}
}

export const SetDefaultExpandedKeys = (expandedKeys)=>{
    return {type:SET_DEFAULT_EXPANDED_KEYS, expandedKeys}
}

export const MarkAttendance = async (attendance)=>{
    if(_.get(attendance, "clientAttendanceId"))
        await Services.Attendance.updateClientAttendance(attendance);
    else
        await Services.Attendance.createClientAttendance(attendance);

    return {type:MARK_ATTENDANCE}
}